<template>
     <div class="tingBa">
                <div class="loading">
          <div class="container">
            <span class="girl"></span>
            <div class="boys">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
      </div>
        <header>
          <h1>活动中心</h1>
        </header>
        <div class="ting-container">
          <ul class="safkz">
            <!-- 1 -->
           
            <li v-for="item in activity_hd">
            <!-- 向详情传入id -->
              <router-link :to="'/activity/cntxx/'+item.act_id">
              <p class="act_li1">{{item.act_title}}</p>
              <div>
                <div class="act_li2">
                  <img :src="'http://ts.winwulian.com/uploads/activity'+'/'+item.act_pic">
                </div>
                <div class="act_li3">
                  <p class="act_li31">{{item.act_describe}}</p>
                  <div class="act_li32">
                    <v-icon name="clock" class="clock"></v-icon>
                    <p>{{item.act_time}}</p>
                  </div>
                </div>
              </div> 
               </router-link>
            </li>
          </ul>
        </div>
        <div style="height: .6rem;width: 100%;background: #FFFFFF;"></div>
        <div class="appNav">
            <ul>
                <router-link to="/">
                <li class="home">
                    <v-icon name="home" class="hv"></v-icon>
                    <p class="hp">首页</p>
                </li>
                </router-link>
                <router-link to="/discover/all">
                <li class="globe">
                    <v-icon name="globe" class="gv"></v-icon>
                    <p class="gp">专辑</p>
                </li>
                </router-link>
                <router-link to="/activity">
                <li class="comments cccc">
                    <v-icon name="comments" class="cv"></v-icon>
                    <p class="cp">活动</p>
                </li>
                </router-link>
                <router-link to="/mine">
                <li class="user">
                    <v-icon name="user" class="uv"></v-icon>
                    <p class="up">个人</p>
                </li>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
    data(){
      return{
        activity_hd:[]
      }
    },
    mounted(){
      setTimeout(function(){
          $('.loading').remove()
        },600)
      this.getAjax();
       
    },
     methods:{
      getAjax:function () {
       var successCallback =  (response) => {
          console.log('服务器请求成功了')
          // console.log(response)
          if(response){
           
            this.activity_hd = response.activity
          }
        }
        var errorCallback =  (response) => {
            console.log('服务器请求出错了')
        }
        this.$http.get(CURL+'/portal/All/getydz').then(successCallback,errorCallback);
      }
},

  
}
</script>

<style lang="scss" scoped>

/*tap*/
.appNav {
  width: 100%;
  height: 0.6rem;
  border-top: 0.01rem solid #f2f2f2;
  background: #ffffff;
  position: fixed;
  bottom:0;
  ul,
  li{
    list-style: none;
  }
  ul{
    li{
        float: left;
        width: 25%;
        text-align: center;
    }
  }
}
.hv,.gv,.cv,.uv{
  margin-top: .13rem;
}
.cccc{
  color: #4eb1d3!important;
}
/*tap*/


.signup{
  position: relative;
  bottom: 45px;
  left: 160px;
  padding: 10px 30px 10px 30px;
  background-color: initial;
}

/*loading*/
.container {
    margin-top: 50%;
    margin-left:18%; 
    width: 55%;
    height: 1em;
    font-size: 35px;
    display: flex;
    justify-content: space-between;
}

.container span {
    width: 15px;
    height: 15px;
    --duration: 1.5s;
}

.girl {
    animation: slide var(--duration) ease-in-out infinite alternate;
}

@keyframes slide {
    from {
        transform: translateX(0);
        filter: brightness(1);
    }

    to {
        transform: translatex(calc(8em - (1em * 1.25)));
        filter: brightness(1.45);
    }
}

.boys {
    width: 65%;
    display: flex;
    justify-content: space-between;
}

.boys span {
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1) {
    animation-name: jump-off-1;
}

.boys span:nth-child(2) {
    animation-name: jump-off-2;
}

.boys span:nth-child(3) {
    animation-name: jump-off-3;
}

.boys span:nth-child(4) {
    animation-name: jump-off-4;
}

@keyframes jump-off-1 {
    0%, 15% {
        transform: rotate(0deg);
    }

    35%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-2 {
    0%, 30% {
        transform: rotate(0deg);
    }

    50%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-3 {
    0%, 45% {
        transform: rotate(0deg);
    }

    65%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-4 {
    0%, 60% {
        transform: rotate(0deg);
    }

    80%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

.container span::before {    
    content: '';
    position: absolute;
    width: inherit;
    height: inherit;
    border-radius: 15%;
    box-shadow: 0 0 0.1em rgba(0, 0, 0, 0.3);
}

.girl::before {
    background-color: #7988da;
}

.boys span::before {
    background-color: dodgerblue;
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1)::before {
    filter: brightness(1);
    animation-name: jump-down-1;
}

.boys span:nth-child(2)::before {
    filter: brightness(1.15);
    animation-name: jump-down-2;
}

.boys span:nth-child(3)::before {
    filter: brightness(1.3);
    animation-name: jump-down-3;
}

.boys span:nth-child(4)::before {
    filter: brightness(1.45);
    animation-name: jump-down-4;
}

@keyframes jump-down-1 {
    5% {
        transform: scale(1, 1);
    }

    15% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    20%, 25% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    40% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    55%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-2 {
    20% {
        transform: scale(1, 1);
    }

    30% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    35%, 40% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    55% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    70%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-3 {
    35% {
        transform: scale(1, 1);
    }

    45% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    50%, 55% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    70% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    85%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-4 {
    50% {
        transform: scale(1, 1);
    }

    60% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    65%, 70% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    85% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    100%, 100% {
        transform: scale(1, 1);
    }
}

.loading{
  background-color:#00a8d9;
  position:fixed;
  z-index:999999;
  top:0;
  left:0;
  width:100%;
  height:100%;
  text-align:center;
  line-height:300px;
  padding-top: 35%;
  padding-left: 5%;
  padding-right: 5%;
}
/**/
.tingBa {
  display: flex;
  flex-direction: column;
  height: auto;
}
.ting-container {
  background-color: #eee;
  flex: 1;
}
header{
  width: 100%;
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  position: fixed;
  h1{
    margin-top: .2rem;
    height: 95%;
    line-height: 0px;
    text-align: center;
    font-size: 19px;
    font-weight: 600;
    color: #FFFFFF;
  }
}
.safkz{
  margin-top: .4rem;
    li{
      height: 150px;
      margin-top: 3px;
      font-size: 13px;
      background-color: #FFFFFF;
    }
  }
.act_li1{
  width:90%;
  float: left;
  height: 40px;
  font-size: 15px;
  font-weight: 650;
  margin: 15px;
}
.act_li2{
  float: left;
  width: 25%;
  height: 75px;
  overflow: hidden;
  margin-left: 15px;
  img{
    width: 100%;
  }
}
.act_li3{
  float: left;
  width: 70%;
}
.act_li31{
  height: 40px;
  font-size: 14px;
  margin: 5px 15px 0 15px;
  overflow: hidden;
}
.act_li32{
  float: right;
  height: 40px;
  margin-right: 15px;
  p{
    float: left;
    margin-top: 5px;
  }
}
.clock{
  float: left;
  margin-top: 5px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/activity/index.vue